import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OverviewService } from 'app/modules/pages/trailer-systems/overview/system-overview.service';
import { Observable, of, throwError, Subscription, interval, BehaviorSubject } from 'rxjs';

import { MapListSliderService } from './map-list-slider.service';

@Component({
  selector: 'map-list-slider',
  templateUrl: 'map-list-slider.component.html',
  styleUrls: ['map-list-slider.component.scss'],
})

export class MapListSliderComponent implements OnInit, AfterViewInit, OnDestroy{
    checked: boolean
    disabled: boolean
    send: string

    map: string = 'm612 936-263-93-179 71q-17 9-33.5-1T120 883V325q0-13 7.5-23t19.5-15l202-71 263 92 178-71q17-8 33.5 1.5T840 268v565q0 11-7.5 19T814 864l-202 72Zm-34-75V356l-196-66v505l196 66Zm60 0 142-47V302l-142 54v505Zm-458-12 142-54V290l-142 47v512Zm458-493v505-505Zm-316-66v505-505Z'
    list: string = 'M149.825 776Q137 776 128.5 767.325q-8.5-8.676-8.5-21.5 0-12.825 8.675-21.325 8.676-8.5 21.5-8.5 12.825 0 21.325 8.675 8.5 8.676 8.5 21.5 0 12.825-8.675 21.325-8.676 8.5-21.5 8.5Zm0-170Q137 606 128.5 597.325q-8.5-8.676-8.5-21.5 0-12.825 8.675-21.325 8.676-8.5 21.5-8.5 12.825 0 21.325 8.675 8.5 8.676 8.5 21.5 0 12.825-8.675 21.325-8.676 8.5-21.5 8.5Zm0-170Q137 436 128.5 427.325q-8.5-8.676-8.5-21.5 0-12.825 8.675-21.325 8.676-8.5 21.5-8.5 12.825 0 21.325 8.675 8.5 8.676 8.5 21.5 0 12.825-8.675 21.325-8.676 8.5-21.5 8.5ZM290 776v-60h550v60H290Zm0-170v-60h550v60H290Zm0-170v-60h550v60H290Z'

    checkSubscription: Subscription
    sendSubscription: Subscription

    constructor(private renderer: Renderer2, public router: Router, private data: MapListSliderService, public overviewService: OverviewService) {}

    @ViewChild('viewswitch', { read: ElementRef }) element: ElementRef | undefined;

    ngOnInit(){
        this.checkSubscription = this.data.checkedServiceVal.subscribe(res => {
            this.checked = res
        })

        this.sendSubscription = this.data.sendServiceVal.subscribe(res => {
            this.send = res
        })

        if (localStorage.getItem("check")){
            if (localStorage.getItem("check") === "true"){
                this.checked = true
            }
            else if (localStorage.getItem("check") === "false"){
                this.checked = false
            }
            //console.log(localStorage.getItem("check"), this.checked)
        }
        
        if (localStorage.getItem("send")){
            if (localStorage.getItem("send") === "map"){
                this.send = 'map'
            }
            else if (localStorage.getItem("send") === "list"){
                this.send = 'list'
            }
            //console.log(localStorage.getItem("send"), this.send)
        }
        
    }


    ngAfterViewInit() {
        this.setIcon();
    }

    ngOnDestroy(){
        this.checkSubscription.unsubscribe()
        this.sendSubscription.unsubscribe()
    }

    setIcon() {
        if (this.element) {
        const targetSpan: HTMLElement = this.element.nativeElement.querySelector('.mat-slide-toggle-thumb');
        while (targetSpan.firstChild) {
            targetSpan.firstChild.remove();
        }
        const elem = this.renderer.createElement('mat-icon');
        const icon = this.checked ? 'map' : 'list';
        this.checked ? elem.setAttribute('class', 'mat-icon notranslate material-icons map') : elem.setAttribute('class', 'mat-icon notranslate material-icons list')
        elem.textContent = icon
        targetSpan.appendChild(elem);

        

        // this.element.nativeElement.querySelector('.mdc-switch__icon--on').firstChild.setAttribute('d', this.map);
        // this.element.nativeElement.querySelector('.mdc-switch__icon--off').firstChild.setAttribute('d', this.list);

        }
    }

    changeTheme() {
        this.checked = !this.checked
        
        this.setIcon();
        
        if (this.checked === true){
            if (this.router.url === '/trailer-systems/list' || this.router.url === '/trailer-systems/map'){
                this.router.navigate([`/trailer-systems/map`])
            }
            this.data.checkedSlider(true)
            this.data.sendSlider('map')

            localStorage.setItem("check", "true")
            localStorage.setItem("send", "map")
        }
        else {
            if (this.router.url === '/trailer-systems/list' || this.router.url === '/trailer-systems/map'){
                this.router.navigate([`/trailer-systems/list`])
            }
            this.data.checkedSlider(false)
            this.data.sendSlider('list')

            localStorage.setItem("check", "false")
            localStorage.setItem("send", "list")
        }
        
    }
    
}